<script setup lang="ts">
import { ChatBubble, WhatsappBold } from '~/components/icons'

const tawk = useTawk()

function openWhatsApp() {
  if (!import.meta.client)
    return
  window.open('https://wa.me/6281809878880', '_blank', 'noopener,noreferrer')
}

function openLiveChat() {
  if (!import.meta.client)
    return
  tawk.openChat()
}
</script>

<template>
  <section>
    <Card class="p-6">
      <h3 class="text-xl font-semibold">
        Perlu bantuan langsung dari tim Rintisan Billing?
      </h3>
      <p class="text-sm mt-1">
        Hubungi kami untuk bantuan cepat mulai dari kendala login, metode pembayaran, dan status pencairan.
      </p>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-5">
        <!-- Live Chat -->
        <Card class="px-5 py-4">
          <div class="flex items-start gap-3">
            <ChatBubble class="size-9 shrink-0" />
            <div class="space-y-6">
              <div>
                <h4 class="font-semibold">
                  Live Chat
                </h4>
                <p class="text-sm mt-1">
                  Dapatkan respons cepat untuk tanya jawab langsung dan panduan langkah demi langkah di halaman ini.
                </p>
              </div>
              <Button
                variant="white"
                class="rounded-full font-semibold"
                @click="openLiveChat"
              >
                Mulai Live Chat
              </Button>
            </div>
          </div>
        </Card>

        <!-- WhatsApp -->
        <Card class="px-5 py-4">
          <div class="flex items-start gap-3">
            <WhatsappBold class="size-9 shrink-0" />
            <div class="space-y-6">
              <div>
                <h4 class="font-semibold">
                  WhatsApp
                </h4>
                <p class="text-sm mt-1">
                  Kirim nomor invoice, bukti pembayaran, atau screenshot error agar kami bisa membantu cek lebih akurat.
                </p>
              </div>
              <Button
                variant="white"
                class="rounded-full font-semibold"
                @click="openWhatsApp"
              >
                Hubungi via WhatsApp
              </Button>
            </div>
          </div>
        </Card>
      </div>
    </Card>
  </section>
</template>
